import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import { username } from './common';

const schema = yup.object().shape({
	username,
});

export const UsernameValidation = yupResolver(schema);
